import { CLOUDINARY_BASE_URL } from '../config/cloudinary.mjs';

const CLOUDINARY_UPLOAD_MARKER = '/image/upload/';

const cleanPath = (path) => String(path || '').replace(/^\/+/, '');

const getBaseUrl = () => {
  return `${String(CLOUDINARY_BASE_URL).replace(/\/$/, '')}/`;
};

const buildTransform = ({
  width = 1200,
  height,
  crop = 'fill',
  gravity = 'auto',
  quality = 'auto',
  format = 'auto',
} = {}) => {
  const transforms = [`f_${format}`, `q_${quality}`];

  if (width) transforms.push(`w_${width}`);
  if (height) transforms.push(`h_${height}`);

  if (width || height) {
    transforms.push(`c_${crop}`, `g_${gravity}`);
  }

  return transforms.join(',');
};

const insertTransformToFullUrl = (src, transform) => {
  const [base, rest] = src.split(CLOUDINARY_UPLOAD_MARKER);

  const versionStart = rest.search(/v\d+\//);
  const cleanRest = versionStart >= 0 ? rest.slice(versionStart) : rest;

  return `${base}${CLOUDINARY_UPLOAD_MARKER}${transform}/${cleanRest}`;
};

export const img = (pathOrUrl, options = {}) => {
  const src = String(pathOrUrl || '');
  const transform = buildTransform(options);

  if (!src) return '';

  if (src.includes(CLOUDINARY_UPLOAD_MARKER)) {
    return insertTransformToFullUrl(src, transform);
  }

  return `${getBaseUrl()}${transform}/${cleanPath(src)}`;
};

export const imageSrcSet = (pathOrUrl, options = {}, widths = [420, 640, 900]) => {
  return widths
    .map((width) => {
      const ratio = options.height && options.width
        ? options.height / options.width
        : null;

      const height = ratio ? Math.round(width * ratio) : undefined;

      return `${img(pathOrUrl, { ...options, width, height })} ${width}w`;
    })
    .join(', ');
};

export const imagePreset = {
  hero: {
    width: 1800,
    height: 1000,
    crop: 'fill',
    quality: 'auto',
  },
  main: {
    width: 1400,
    height: 820,
    crop: 'fill',
    quality: 'auto',
  },
  card: {
    width: 640,
    height: 420,
    crop: 'fill',
    quality: 'auto',
  },
  tourCard: {
    width: 720,
    height: 520,
    crop: 'fill',
    quality: 'auto',
  },
  optionCard: {
    width: 640,
    height: 420,
    crop: 'fill',
    quality: 'auto',
  },
  timeline: {
    width: 560,
    height: 360,
    crop: 'fill',
    quality: 'auto',
  },
  thumb: {
    width: 420,
    height: 280,
    crop: 'fill',
    quality: 'auto',
  },
  square: {
    width: 520,
    height: 520,
    crop: 'fill',
    quality: 'auto',
  },
};
